import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Tabs,
  Tab,
  ButtonToolbar,
  Modal,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  CardHeaderTitle,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import {
  fetchId,
  fetchRole,
  selectRole,
  selectDataId,
  editItem,
  addOfficeUser,
  selectDataIdUser,
  fetchIdUser,
  editEmployee,
  removeUserOffice,
  unlockUserUpdate,
  resetUserUpdate,
  selectRoleModal,
  fetchRoleModal,
  editOfficeUser,
} from "../user/userSlice";
import {
  showConfirmDialog,
  showDeleteDialog,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import { fetchOffice, selectOffice } from "../office/officeSlice";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";

import { makeStyles, fade } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import {
  fetchParameter,
  fetchParameter2,
  selectParameter,
  selectParameter2,
} from "../businessParameter/businessParameterSlice";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  MenuItem,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { ModalOffice } from "./ModalOffice";
import { ModalClient } from "./ModalClient";
import {
  addLabelTpl,
  editLabelTpl,
  fetchIdLabelTpl,
  selectIdLabelTpl,
  selectLoading,
} from "./motorPoolSlice";

const useStylesReddit = makeStyles((theme) => ({
  root: {
    border: "1px solid #e2e2e1",
    overflow: "hidden",
    borderRadius: 4,
    backgroundColor: "#FFFFFF",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:hover": {
      backgroundColor: "#fff",
    },
    "&$focused": {
      backgroundColor: "#fff",
      boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
      borderColor: theme.palette.primary.main,
    },
  },
  focused: {},
}));
function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export const LabelTemplateView = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const dataId = useSelector(selectIdLabelTpl);
  const dataOffice = useSelector(selectOffice);
  const dataUser = useSelector(selectDataIdUser);
  const dataActivities = useSelector(selectParameter);
  const dataServices = useSelector(selectParameter2);
  const { id } = useParams();

  const [listOffice, setListOffice] = useState([]);
  const [listClient, setListClient] = useState([]);
  const [activities, setActivities] = useState([]);
  const [services, setServices] = useState([]);
  const [copies, setCopies] = useState("");

  const [fileName, setFileName] = useState("Upload Template File*");

  console.log(dataId, "dataId");

  // initial

  const [formValues, setFormValues] = useState({
    labeltpl_type: {
      value: "",
      error: false,
      required: "Y",
    },
    labeltpl_name: {
      value: "",
      error: false,
      required: "Y",
    },
    labeltpl_description: {
      value: "",
      error: false,
      required: "N",
    },
  });

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load
      await dispatch(fetchIdLabelTpl(id));
    }
    fetchMyAPI();
  }, [dispatch]);

  // HanldeSave

  const columns = [
    {
      text: "Office Code",
      dataField: "office_code",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Office Name",
      dataField: "office_name",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "City",
      dataField: "City",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Country",
      dataField: "country_name",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
  ];

  const columnsClient = [
    {
      text: "Client Code",
      dataField: "client_code",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Client Name",
      dataField: "client_name",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "City",
      dataField: "city",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Country",
      dataField: "country_name",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
  ];

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      {dataId && (
        <Card>
          <CardHeader>
            <CardHeaderTitle className="card-title text-white ">
              View Label Template : {dataId.labeltpl_name}
            </CardHeaderTitle>
            <CardHeaderToolbar>
              <Button className="primary" onClick={() => history.goBack()}>
                Back To List
              </Button>
            </CardHeaderToolbar>
          </CardHeader>

          <CardBody>
            <>
              {/* label */}
              <div>
                <Row>
                  <Col xs={12} sm={3} md={6} lg={6}>
                    <RedditTextField
                      label="Label Type"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      value={dataId.labeltpl_type}
                      readOnly
                    />
                    <RedditTextField
                      label="Description"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      value={dataId.labeltpl_description}
                      readOnly
                    />
                  </Col>
                  <Col xs={12} sm={3} md={6} lg={6}>
                    <RedditTextField
                      label="Label Name"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      value={dataId.labeltpl_name}
                      readOnly
                    />
                  </Col>
                </Row>
              </div>
              <hr />
              {/* services/activties */}

              <div>
                <h5 className="text-bold">Associated Services/Activities</h5>
                <CardBody>
                  <div>
                    <p className="text-bold">Activities</p>
                    <Row>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        {dataId.activities === null
                          ? []
                          : dataId.activities.map((item, index) => {
                              return (
                                <Form.Check
                                  disabled
                                  inline
                                  label={item.activities_code}
                                  name="group1"
                                  type="checkbox"
                                  className="mr-8 mb-4"
                                  checked={true}
                                />
                              );
                            })}
                      </Col>
                    </Row>
                  </div>
                  <div>
                    <p className="text-bold">Services/Processes</p>
                    <Row>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        {dataId.services === null
                          ? []
                          : dataId.services.map((item, index) => {
                              return (
                                <Form.Check
                                  disabled
                                  inline
                                  label={item.service_code}
                                  name="group1"
                                  type="checkbox"
                                  className="mr-8 mb-4"
                                  checked={true}
                                />
                              );
                            })}
                      </Col>
                    </Row>
                  </div>
                </CardBody>
              </div>
              <hr />
              {/* Parameter */}
              <div>
                <h5 className="text-bold">Parameter</h5>
                <Form.Check
                  inline
                  label="No. of Copies"
                  name="group1"
                  type="checkbox"
                  className="mr-8 mb-4"
                />
              </div>
              <hr />
              {/* Template File */}
              <div>
                <h5 className="text-bold">Template File</h5>
                <Row>
                  <Col xs={12} sm={3} md={6} lg={6}>
                    {" "}
                    <Form.File
                      type="file"
                      id="file_fpre"
                      custom
                      label={fileName}
                      // onChange={(e) => setFileName(e.target.files[0].name)}
                      accept="application/pdf,image/png, image/jpg, image/jpeg"
                    />
                  </Col>
                </Row>
              </div>

              <hr />
              {/* Office */}
              <div>
                <h5 className="text-bold">Office</h5>

                <BootstrapTable
                  wrapperClasses="table-responsive"
                  classes="table table-head-custom table-vertical-center overflow-hidden rounded table-container"
                  bootstrap4
                  
                  keyField="No"
                  data={dataId.offices === null ? [] : dataId.offices}
                  columns={columns}
                  // sort={{ dataField: sortField, order: sortOrder }}
                  hover
                  striped
                  headerClasses="header-class"
                />
              </div>
              <hr />
              {/* Client */}
              <div>
                <h5 className="text-bold">Clients</h5>

                <BootstrapTable
                  wrapperClasses="table-responsive"
                  classes="table table-head-custom table-vertical-center overflow-hidden rounded table-container"
                  bootstrap4
                  
                  keyField="client_id"
                  data={dataId.clients === null ? [] : dataId.clients}
                  columns={columnsClient}
                  hover
                  striped
                  headerClasses="header-class"
                />
              </div>
              <hr />
            </>
          </CardBody>
        </Card>
      )}
    </>
  );
};
